"use strict";

export var sharedData = {
  //проставлятеся когда наживается кнопка "редактировать/добавить" в тулбаре или открывается форма редактированяи
  formEditProcessed: false,
  //производится редактирование в строке ['add', 'edit', false]
  inlineEditing: false,
  //присваиваеться значение key field строки таблицы, которую необходимо выделить при закрытии полноекранной формы редактирования
  lastRowIndex: null
};